import { ReactComponent as Punto } from './punto.svg';
import { ReactComponent as Raggio } from './raggio.svg';
import { ReactComponent as Diametro } from './diametro.svg';
import { ReactComponent as Corda } from './corda.svg';
import { ReactComponent as Arco } from './arco.svg';
import { ReactComponent as Settore } from './settore.svg';
import { ReactComponent as Semicerchio } from './semicerchio.svg';
import { ReactComponent as Circonferenza } from './circonferenza.svg';
import { ReactComponent as Cerchio } from './cerchio.svg';

export const FORME_CERCHIO_ICONS = {
  punto: Punto,
  raggio: Raggio,
  diametro: Diametro,
  corda: Corda,
  arco: Arco,
  settore: Settore,
  semicerchio: Semicerchio,
  circonferenza: Circonferenza,
  cerchio: Cerchio,
};
